// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2m6PH","toggleWrap":"styles_toggleWrap__1PeZ6","content":"styles_content__2nMfG","selectAreaCode":"styles_selectAreaCode__1AQs2"};